export default __webpack_public_path__ + "static/SectionTwo_02_04@2x-a0d24cdd5113a40f196f111541dead62.webp";